"use client";

import Container from "@/components/common/Container";
import Wrapper from "@/components/common/Wrapper";
import clsx from "clsx";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

function SkeletonLine({ className = "" }: Readonly<{ className?: string }>) {
  return (
    <div className={clsx("animate-pulse rounded-full bg-gail-silver/30", className)} />
  );
}

export default function JobDetailsLoadingPage() {
  const { t } = useTranslation();

  // Match the page behavior: a streamed loading boundary skips Next's
  // scroll-to-top, so restore it here.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container headerVariant="redesign">
      <Wrapper
        fullWidth
        className="py-10 md:py-14 w-full max-w-5xl px-4!"
        aria-label={t("careers.loadingJobs")}
        aria-busy="true"
      >
        <SkeletonLine className="h-4 w-32" />

        <div className="mt-6 overflow-hidden rounded-3xl border border-black/10">
          <div className="space-y-5 px-6 py-8 sm:px-10 sm:py-12 border-b bg-marketing-voice-card border-black/10">
            <SkeletonLine className="h-6 w-28 bg-white/60" />
            <SkeletonLine className="h-10 w-3/4 bg-white/60" />
            <div className="flex flex-wrap gap-3 pt-2">
              <SkeletonLine className="h-8 w-40 bg-white/60" />
              <SkeletonLine className="h-8 w-32 bg-white/60" />
              <SkeletonLine className="h-10 w-28 bg-white/60" />
            </div>
          </div>

          <div className="space-y-6 bg-white px-6 py-8 sm:px-10 sm:py-12">
            <SkeletonLine className="h-7 w-48" />
            <SkeletonLine className="h-4 w-full" />
            <SkeletonLine className="h-4 w-11/12" />
            <SkeletonLine className="h-4 w-10/12" />
            <div className="pt-6 space-y-3">
              <SkeletonLine className="h-4 w-full" />
              <SkeletonLine className="h-4 w-11/12" />
              <SkeletonLine className="h-4 w-9/12" />
              <SkeletonLine className="h-4 w-10/12" />
            </div>
          </div>
        </div>
      </Wrapper>
    </Container>
  );
}
